import { Stack } from "@mantine/core";
import classes from "./FeedbackFields.module.css";
import type { AppFieldExtendedReactFormApi } from "@tanstack/react-form";

interface FeedbackFieldsProps {
  form: AppFieldExtendedReactFormApi<
    { email: string; message: string },
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any,
    any
  >;
}

export const FeedbackFields = ({ form }: FeedbackFieldsProps) => (
    <Stack gap="xxs" className={classes.container}>
      <form.AppField
        name="email"
        children={(field: any) => (
          <field.TextField
            label="Email"
            placeholder="Enter your email"
            required
            radius="md"
            className={classes.field}
          />
        )}
      />

      <form.AppField
        name="message"
        children={(field: any) => (
          <field.TextAreaField
            label="Your feedback"
            placeholder="Tell us what you think..."
            required
            minRows={4}
            autosize
            radius="md"
            className={classes.field}
          />
        )}
      />
    </Stack>
);
